<template>
  <div class="container">
    <div class="horizontal-container">
      <div class="scroll-wrapper" ref="scroll">
        <div class="scroll-content">
          <div
            class="scroll-item"
            v-for="(item, index) in examLabels"
            :key="index"
          >
            <div
              :class="
                selectTag == item.examLabelId
                  ? 'tag-item-select'
                  : 'tag-item-normal'
              "
              :key="item.name"
              @click="onTagClick(item)"
            >
              <div
                :class="
                  selectTag == item.examLabelId
                    ? 'tag-item-text-select'
                    : 'tag-item-text-normal'
                "
              >
                {{ item.title }}>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-list
      ref="articleList"
      v-if="this.selectTag"
      v-model="loading"
      :finished="finished"
      finished-text="— 我是有底线的 —"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" style="margin: 15px 0">
        <!-- <div>{{item.date}}</div> -->
        <!-- <div v-if="item.type == 1">
          <div
            v-if="item.article"
            class="card-item"
            @click="onArticleClick(item.article)"
          >
            <div class="article-image-container">
              <div>
                <img class="article-intro-image" :src="item.article.imageUrl" />
              </div>
            </div>
            <div v-if="item.article.keyword" class="article-catagory">
              — {{ item.article.keyword }} —
            </div>
            <div v-if="item.article.title" class="article-desc-en">
              {{ item.article.title.replace(/&nbsp;/g, " ") }}
            </div>
            <div v-if="item.article.titleCn" class="article-desc-cn">
              {{ item.article.titleCn.replace(/&nbsp;/g, " ") }}
            </div>
            <div
              v-if="item.article.source || item.article.sourceCn"
              class="article-source"
            >
              选自<span v-if="item.article.source"
                >{{ `${item.article.source} ` }} </span
              ><span v-if="item.article.sourceCn">{{
                `(${item.article.sourceCn})`
              }}</span>
            </div>
            <div style="height: 38px"></div>
          </div>
        </div> -->

        <!-- hasCollect 2:没有收藏按钮 -->
        <article-card-item
        v-if="item.type == 1"
        :index="index"
        :data="item"
        :onClickCollect="onClickCollect"
        :onArticleClick="onArticleClick"
        :hasCollect="2"
      />
        <div v-if="item.type == 2 && item.collection" class="card-item">
          <div class="article-image-container">
            <div>
              <img
                class="article-intro-image"
                :src="item.collection.imageUrl"
              />
            </div>
            <div class="small_pic"></div>
          </div>
          <div style="padding: 0 18px; text-align: center; margin-bottom: 24px">
            <div v-if="item.collection.title" class="article-collection-title">
              {{ item.collection.title.replace(/&nbsp;/g, " ") }}
            </div>
            <div v-if="item.collection.label" class="article-collection-tag">
              {{ item.collection.label }}
            </div>
            <div
              v-if="item.collection.description"
              class="article-collection-desc"
            >
              {{ item.collection.description }}
            </div>
          </div>
          <div class="divider" />
          <div
            v-if="item.collection.articles"
            style="width: 100%; padding: 0 18px"
          >
            <div
              class="article-collection-list-item"
              v-for="article in item.collection.articles"
              :key="article.articleId"
              @click="onArticleClick(article)"
            >
              <div>
                <img
                  class="article-collection-list-item-image"
                  :src="article.subImageUrl"
                />
              </div>
              <div class="article-collection-list-item-text-container">
                <div v-if="article.titleCn" class="article-item-title-cn">
                  {{ article.titleCn.replace(/&nbsp;/g, " ") }}
                </div>
                <div v-if="article.title" class="article-item-title-en">
                  {{ article.title.replace(/&nbsp;/g, " ") }}
                </div>
              </div>
            </div>
          </div>
          <div class="article-collection-more" @click="onMoreClick(item)">
            {{ `查看${item.collection.total}篇精选文章>>` }}
          </div>
        </div>
      </div>
      <template #finished>
        <div style="font-size: 10px">— 我是有底线的 —</div>
      </template>
    </van-list>
  </div>
</template>

<script>
import moment from "moment";
import { Toast } from "vant";
import BScroll from "@better-scroll/core";
import DateLabel from "./component/DateLabel";
import { getExamArticleList, getExamLableList } from "../../../api/article";
import _ from "lodash";
import ArticleCardItem from "./component/ArticleCardItem";

export default {
  name: "RecommendList",
  components: {
    DateLabel,
    ArticleCardItem
  },
  data() {
    return {
      selectTag: 0,
      loading: false,
      finished: false,
      examLabels: [],
      pageSize: 6,
      pageIndex: 1,
      list: [],
    };
  },
  activated() {
    // this.bs && this.bs.refresh();
  },
  mounted() {
    getExamLableList().then((result) => {
      this.examLabels = result.data;
      this.selectTag = _.get(this.examLabels, [0, "examLabelId"], 0);
      this.$nextTick(() => {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3, // listening scroll hook
        click: true,
      });
      this._registerHooks(["scroll", "scrollEnd"], (pos) => {
        console.log("done");
      });
    });
    });
    
  },
  beforeDestroy() {
    this.bs && this.bs.destroy();
  },
  methods: {
    onTagClick(tag) {
      if (this.selectTag != tag.examLabelId) {
        this.selectTag = tag.examLabelId;
        this.finished = false;
        this.loading = false;
        this.list = [];
        this.pageIndex = 1;
        this.$nextTick(() => {
          this.$refs.articleList.check();
        });
      }
    },
    _registerHooks(hookNames, handler) {
      hookNames.forEach((name) => {
        this.bs.on(name, handler);
      });
    },
    onMoreClick(item) {
      this.$router.push({
        path: "/moreArticle",
        query: { collectionId: item.collection.collectionId },
      });
    },
    onArticleClick(item) {
      this.$router.push({
        path: "/articleGuide",
        query: { articleId: item.articleId },
      });
    },
    onLoad() {
      getExamArticleList({
        examLabelId: this.selectTag,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((result) => {
          this.list = _.concat(this.list, result.data.records);
          this.pageIndex++;
          this.loading = false;
          if (result.data.records.length < this.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {});
    },
    onClickCollect() {

    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  padding: 0 3vw;
  display: flex;
  flex-direction: column;
}

.divider {
  background-color: #e3e3e3;
  height: 1px;
  width: 90%;
}

.horizontal-container {
  .scroll-wrapper {
    width: 100%;
    margin: 6px auto;
    white-space: nowrap;
    overflow: hidden;

    .scroll-content {
      display: inline-block;
      vertical-align: center;
    }

    .scroll-item {
      line-height: 100%;
      font-size: 24px;
      display: inline-block;
      text-align: center;
      padding: 0 10px;
    }
  }
}

.article-collection-list-item {
  height: 82px;
  padding: 0 18px;
  display: flex;
  margin: 10px 0;
}

.article-collection-list-item-image {
  width: 82px;
  height: 82px;
  border-radius: 6px;
}

.article-collection-list-item-text-container {
  justify-content: center;
  display: flex;
  margin-left: 10px;
  flex-direction: column;
}

.article-item-title-cn {
  font-family: serif, SimSun, STSong;
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 12px;
}

.article-item-title-en {
  font-family: serif, SimSun, STSong;
  font-size: 11px;
}

.article-collection-title {
  margin-top: 23px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-desc {
  margin-top: 20px;
  font-size: 12px;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-tag {
  margin-top: 20px;
  font-size: 11px;
  color: #3994E7;
  font-family: serif, SimSun, STSong;
}

.article-collection-more {
  line-height: 50px;
  color: #3994E7;
  font-size: 12px;
}

// .tab-item-text {
// color: #3994E7;
// }
.card-item {
  // background-color :
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 20px 100px 0px #d6d6d6;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.article-image-container {
  display: flex;
  position: relative;
  text-align: center;
}

.article-intro-image {
  position: relative;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.article-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12vw;
  height: 12vw;
  transform: translate(-50%, -50%);
}

.article-catagory {
  margin-top: 24px;
  font-size: 13px;
  font-weight: bold;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.article-desc-en {
  margin: 0 15px;
  margin-top: 24px;
  font-size: 14px;
  text-align: center;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-desc-cn {
  margin-top: 15px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  font-family: serif, SimSun, STSong;
}

.article-source {
  margin-top: 15px;
  font-size: 11px;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.card-container {
  width: 100%;
}

.tag-item {
  &-select {
    display: inline-block;
    height: 20px;
    padding: 2px 10px;
    margin-right: 4px;
    font-weight: bold;
    background: linear-gradient(top, #98CEFF, #3994E7);
    border-radius: 12px;
    font-size: 12px;
  }

  &-normal {
    display: inline-block;
    height: 20px;
    padding: 2px 10px;
    background: #e4ebf6;
    border-radius: 12px;
    margin-right: 4px;
    font-size: 12px;
  }
}

.tag-item-text-select {
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
}

.tag-item-text-normal {
  font-size: 12px;
  line-height: 20px;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// app/pages/tabs/Home/ExamCategoryList.vue